import { ADMIN_ROLES } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

import { AuthController } from '../auth-controller';

export class PaymentProfilesController extends AuthController {
  public pageId = 'paymentProfiles';
  public path = '/admn/partnerOverview/payment-profiles';
  public routeName = 'paymentProfiles';
  public bundles = [];
  public pageTitle = 'controllers.paymentProfiles';
  public isAdminView = true;
  public accessRoles = [
    ADMIN_ROLES.INTERNAL_COLLECTIONS_MANAGER,
    ADMIN_ROLES.INTERNAL_ADMIN,
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
  ];

  public readOnlyAccessRoles = [
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
  ];

  public component = codeSplit(
    () => import(/* webpackChunkName: "paymentProfiles" */ '../../views/admin/payment-profiles'),
  );
  public exact = true;
}
